export const INCOME_WORKING_TIME_REPORT = {
  IncomeSummary: '/report/netincomes-wkt',
  ExportIncomeSummary: '/report/netincomes-wkt/export',
  IncomeDetails: '/report/netincomes-wkt/details',
  ReportSummary: '/report/netincomes-wkt/report-summary',
  ReportDetails: '/report/netincomes-wkt/report-details',
  ReportFullDetails: '/report/netincomes-wkt/report-full-details',
};
